/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgChartsModule } from 'ng2-charts';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { environment } from '../environments/environment';
import { ServiceProxyModule } from '../shared/service-proxies/service-proxy.module';
import { API_BASE_URL } from '../shared/service-proxies/event-service-proxy';
import { ErrorInterceptor, JwtInterceptor } from './@core/helpers';
import { RouterModule } from '@angular/router';
import { PrintTemplateComponent } from './print-template/print-template.component';
import { PrintService } from './@core/service';
import { InvoiceTemplateComponent } from './invoice-template/invoice-template.component';
import { OrdersModule } from './pages/orders/orders.module';
import { BillingModule } from './pages/billing/billing.module';

export function getRemoteServiceBaseUrl(): string {
  return environment.urlAddress;
}



@NgModule({
  declarations: [
    AppComponent,
    PrintTemplateComponent,
    InvoiceTemplateComponent
  ],
  imports: [
  
    RouterModule,
    ServiceProxyModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    NgChartsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
  ],
  bootstrap: [
    AppComponent,
  
  ],
  providers: [

  { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  PrintService
  ],
})
export class AppModule {
}
